import { useTranslation } from 'react-i18next';
import AssistanceSection, { useAssistanceSectionContext } from '../AssistanceSection';
import { useAssistanceViewContext } from '../AssistanceViewContext';
import classnames from '../../../../core/utils/classnames.tsx';

import * as React from 'react';
import { mergeRefs } from '../../../../core/utils/mergeRefs.tsx';

export interface ItemDataFieldGroupProps {
    itemIndex: number;
    setIndex?: number;
    title: React.ReactNode;
    fields: any[];
    children: React.ReactNode;
    controls: React.ReactNode;
    wrapperRef?: React.RefObject<any>;
    isDragging?: boolean;
}

export const useItemDataFieldGroupProps = ({
    itemIndex,
    setIndex,
    title,
    controls,
    isDragging,
}: ItemDataFieldGroupProps) => {
    const { viewMode } = useAssistanceSectionContext();
    const { onItemMouseEnter, onItemMouseLeave } = useAssistanceViewContext();

    return {
        title,
        className: classnames(
            'js-form-item-group',
            viewMode !== 'list' ? 'items-start scroll-mt-10' : 'scroll-mt-20',
            isDragging && '!outline outline-line-brand-weak outline-2'
        ),
        'data-set-index': setIndex,
        'data-item-index': itemIndex,
        onMouseEnter: () => onItemMouseEnter(itemIndex),
        onMouseLeave: () => onItemMouseLeave(itemIndex),
        controls,
    };
};

export const ItemDataFieldGroup = React.forwardRef<HTMLDivElement, ItemDataFieldGroupProps>((props, ref) => {
    const fieldGroupProps = useItemDataFieldGroupProps(props);
    const finalRef = mergeRefs(ref, props.wrapperRef);

    return (
        <AssistanceSection.FieldGroup ref={finalRef} {...fieldGroupProps}>
            {props.children}
        </AssistanceSection.FieldGroup>
    );
});

ItemDataFieldGroup.displayName = 'ItemDataFieldGroup';

export default ItemDataFieldGroup;
